<div [formGroup]="parts">

  <mat-select  formControlName="selectedId" [compareWith]="compareFn"   (selectionChange)="fireChange()">
    <mat-option *ngFor="let item of options" [value]="item.id">
      {{item.name}}
    </mat-option>
  </mat-select>

</div>